import type { SelectOption } from "lib/components/Select";
import { SortTypeCommunity } from "lib/enums";

const sortCommunity: SelectOption[] = [
  {
    value: SortTypeCommunity.Recent,
    label: "Recent",
    key: SortTypeCommunity.Recent,
  },
  {
    value: SortTypeCommunity.MostLiked,
    label: "Most liked",
    key: SortTypeCommunity.MostLiked,
  },
  {
    value: SortTypeCommunity.MostCommented,
    label: "Most commented",
    key: SortTypeCommunity.MostCommented,
  },
];

export default sortCommunity;
